import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-echarts-header" }
const _hoisted_2 = { class: "home-echarts-header__title" }

import { ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { Ref, PropType } from 'vue'

const __default__ = { name: 'RegionDistributionChart' }

interface ItemType {
  id: string
  name: string
  num: number
}
interface RegionDistributionEchartProps {
  regionVos: ItemType[]
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  value: {
    type: Object as PropType<RegionDistributionEchartProps>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  spinning: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const props = __props

const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: ItemType[]) => {
  const xAxisData: string[] = data.map((item) => item.name)
  const seriesData: number[] = data.map((item) => item.num)
  setOptions({
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '80',
      right: '50'
    },
    calculable: false,
    xAxis: [
      {
        type: 'category',
        data: xAxisData,
        axisLabel: {
          // 倾斜的程度
          formatter: function (value: any) {
            if (value.length > 7) {
              return `${value.slice(0, 7)}...`
            }
            return value
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLabel: {
          // 倾斜的程度
          margin: 2,
          formatter: function (value: any) {
            if (value >= 10000 && value < 100000000) {
              value = value / 10000 + '万'
            } else if (value >= 100000000 && value < 1000000000000) {
              value = value / 100000000 + '亿'
            } else if (value >= 1000000000000) {
              value = value / 1000000000000 + '兆'
            }
            return value
          }
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      }
    ],
    series: [
      {
        type: 'bar',
        name: props.title,
        itemStyle: { color: '#3F97FF' },
        data: seriesData
      }
    ]
  })
}

watch(
  () => props.value,
  (newValue) => {
    if (newValue && newValue.regionVos && newValue.regionVos.length > 0) {
      showECharts.value = true
      setTimeout(() => initChart(newValue.regionVos))
    } else {
      showECharts.value = false
      setTimeout(() => initChart([]))
    }
  },
  {
    deep: true,
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_a_spin, {
      spinning: __props.spinning,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})